/** REST mount on the SGRC API process. Health, uploads, and Socket.IO stay at origin root. */
export const API_PATH_PREFIX = '/api';

/**
 * Append `/api` to an origin (or relative base) unless it already ends with `/api` or `/v1`.
 * Empty / same-origin callers become `/api`.
 *
 * @param {string} [baseURL]
 * @returns {string}
 */
export function withApiBaseUrl(baseURL = '') {
    const raw = String(baseURL || '').trim();
    if (!raw || raw === '/') return API_PATH_PREFIX;

    const stripped = raw.replace(/\/+$/, '');
    if (stripped === API_PATH_PREFIX || stripped === '/v1') return stripped;

    try {
        const url = new URL(stripped);
        const path = url.pathname.replace(/\/+$/, '') || '/';
        if (path === API_PATH_PREFIX || path.startsWith(`${API_PATH_PREFIX}/`) || path === '/v1' || path.startsWith('/v1/')) {
            return stripped;
        }
        url.pathname = path === '/' ? API_PATH_PREFIX : `${path}${API_PATH_PREFIX}`;
        return url.toString().replace(/\/$/, '');
    } catch {
        if (stripped === API_PATH_PREFIX || stripped.startsWith(`${API_PATH_PREFIX}/`) || stripped === '/v1' || stripped.startsWith('/v1/')) {
            return stripped;
        }
        return `${stripped}${API_PATH_PREFIX}`;
    }
}

/**
 * Origin used for /health, /uploads, and Socket.IO (never includes `/api`).
 *
 * @param {string} [baseURL]
 * @returns {string}
 */
export function apiOrigin(baseURL = '') {
    const raw = String(baseURL || '').trim().replace(/\/+$/, '');
    if (!raw || raw === '/' || raw === API_PATH_PREFIX || raw === '/v1') return '';
    try {
        const url = new URL(raw);
        if (url.pathname === API_PATH_PREFIX || url.pathname.startsWith(`${API_PATH_PREFIX}/`) || url.pathname === '/v1' || url.pathname.startsWith('/v1/')) {
            return url.origin;
        }
        return raw.replace(/\/(api|v1)$/i, '');
    } catch {
        return raw.replace(/\/(api|v1)$/i, '');
    }
}
